var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointDown } from '@lean-body/components/styles/variables';
import Player from '@vimeo/player';
import { VIMEO_URL } from '../constants';
import { VIMEO_EVENT_PLAY, VIMEO_EVENT_TIMEUPDATE, } from '../../infra/vimeo';
export const Vimeo = ({ liveLesson, onInit, onPlay, onTimeupdate }) => {
    const vimeoPlayerUrl = liveLesson.playerUrl;
    const videoId = vimeoPlayerUrl != null ? vimeoPlayerUrl.replace(`${VIMEO_URL}/`, '') : '';
    useEffect(() => {
        // vimeoの動画プレイヤーの仕様は https://developer.vimeo.com/player/sdk/reference を参照
        // iframeがレンダリングされてからDOMを取得したいためuseEffect内で実行
        const iframe = document.getElementById(videoId);
        const player = new Player(iframe);
        // iframeの再生ボタン押下時に発火
        player.on(VIMEO_EVENT_PLAY, (data) => __awaiter(void 0, void 0, void 0, function* () {
            if (data) {
                onPlay(data.seconds);
            }
        }));
        // 動画が再生されている時のハンドリング(250msずつ実行される)
        player.on(VIMEO_EVENT_TIMEUPDATE, (data) => {
            if (data) {
                onTimeupdate(data.seconds);
            }
        });
        onInit();
    }, []);
    return (React.createElement("div", { className: css(styles.embedContainer) },
        React.createElement("iframe", { id: videoId, className: css(styles.iframe), src: vimeoPlayerUrl, frameBorder: "0", allow: "autoplay; fullscreen", allowFullScreen: true })));
};
const styles = StyleSheet.create({
    embedContainer: {
        [MediaBreakPointDown.SM]: {
            width: '100%',
            position: 'relative',
            top: '-2px',
            margin: '0 auto',
        },
        padding: '56.25% 0 0 0',
        position: 'relative',
    },
    iframe: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
    },
});
